<script>
import parseDate from 'date-fns/parse'
import lazyLoadComponent from '@router/lazyload-component'
import { debounce } from 'lodash'

import Layout from '@layouts/main'
import BaseButtonDialog from '@components/BaseButtonDialog'
// import draggable from 'vuedraggable'
import ElTableDraggable from 'element-ui-el-table-draggable'

import pageMixin from '@src/mixins/pagination'

import { productTypeList, productTypeFilter, prepaidCapacityFilter, defaultStatusFilter } from '@utils/filter-value-to-text'
import formatDate, { formatDateRange } from '@utils/format-date'
import { authComputed } from '@state/helpers'
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxDelete } from '@utils/message-box'

export default {
  page: {
    title: '儲值金方案',
    meta: [{ name: 'description', content: 'Deposit List' }],
  },
  components: {
    Layout,
    BaseButtonDialog,
    ElTableDraggable,
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
  },
  filters: {
    productTypeFilter,
    defaultStatusFilter,
    prepaidCapacityFilter,
    formatDate,
    formatDateRange,
  },
  mixins: [pageMixin],
  props: {

    // category: {
    //   type: Array,
    //   required: true,
    // },

  },
  data() {
    return {
      tableData: [],
      selectedDeposits: [],
      filterData: {
        state:'',
        mode:''
      },
      productTypeList: Object.freeze(productTypeList),
      productListPrepaid: [],
      productIds: [],
      cacheTableData: [],
      pageSize:10,
      tryingFetch:false,
      // options: [],
      // drag: false,
      action: '',
    }
  },
  computed: {
    ...authComputed,
    disabledAction() {
      return this.selectedDeposits.length === 0
    },
    isOrderManager() {
      return !this.currentUserRoutes.includes('add-prepaid') && this.currentUserRoutes.includes('prepaid')
    },
  },
  watch: {
    currentPage: {
      handler: 'tryToFetchList',
      immediate: false,
    },
    // filterData: {
    //   handler() {
    //     this.isFilterChange = true
    //   },
    //   deep: true,
    // },
    pageSize: {
      handler(){
        this.tryToFetchList()
        this.currentPage=1
      },
      immediate: false,
    },
  },
  created() {
    const page = this.$route.params.pagination
    if(page){
      const data = {...this.$route.params.filterData}
      this.filterData.productIds = data.productIds
      this.filterData.categoryId = data.categoryId
      this.filterData.search = data.search
      // this.tryToFetchListPage(data,page)
      this.currentPage=page
      if(this.currentPage === 1){
        this.tryToFetchList()
      }

    }else{
      this.tryToFetchList('filter')
    }
    // const filterData = this.$route.params.filterData
    // if(this.$route.params.filterData){
    //   this.filterData = 
    // }
    // this.tryToSearchProduct()
  },
  mounted() {
    // console.log(this.$refs.fff)
  },
  methods: {
    async tryToFetchList(type) {
       // 當篩選前不在第一頁的時候，跳回第一頁
      if (this.currentPage !== 1 && type === 'filter') {
        this.currentPage = 1
        return
      }
      this.tryingFetch = true
      const query = {...this.filterData}
      const { items, total } = await this.$store.dispatch('deposit/fetchList', Object.assign(query, this.pageQuery,{
        limit:this.pageSize
      }))
      this.tableData = items
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
      })
      this.tryingFetch = false
    },
    checkAvailability(row) {
      const now = new Date()
      const { state, startDate, endDate } = row
      if (state === 0) return false

      if (startDate && endDate) return now >= parseDate(startDate) && now <= parseDate(endDate)
      if (!startDate) return now <= parseDate(endDate)
      if (!endDate) return now >= parseDate(startDate)
      return state
    },
    goToViewPage(row) {
      const id = row.id
      this.$router.push({
        name:'view-deposit',
        params:{
          id
        }
      })
    },
    goToAddDeposit(data) {
      this.$router.push({
        name: 'add-deposit',
        params: {
          data,
          pagination:this.currentPage,
          filterData:this.filterData
        },
      })
    },
    async handleBulkUpdateState(state) {
      const prepaidIds = this.selectedDeposits.map(({ id }) => id)
      await this.$store.dispatch('prepaid/updateState', {
        ids: prepaidIds,
        state,
      })
      this.tryToFetchList()
    },
    async handleStoreDeposit(state) {
      if (state === -2)
        await messageBoxDelete('儲值金方案')

      try {
        const depositIds = this.selectedDeposits
        await this.$store.dispatch('deposit/updateState', { ids: depositIds, state })
        if (state === -2)
          messageDelete()
        this.action = ''
        this.tryToFetchList()
      } finally {

      }
    },
    handleSelectionChange(selected) {
      this.selectedDeposits = selected.map(({ id }) => id)
    },
    handleResetSearch() {
      // this.filterData.productIds = ''
      this.filterData =  {
        state:'',
        mode:''
      }
      this.tryToFetchList()
    },
    
    startDraggable() {
      this.cacheTableData = [...this.tableData]
    },
    endDraggable({ targetObject, list }) {
      const preIndex = this.cacheTableData.map((item) => item.id).indexOf(targetObject.id)
      const nextIndex = this.tableData.map((item) => item.id).indexOf(targetObject.id)
      const draggableChange = nextIndex - preIndex
      this.tryToOrderingPrepaid(targetObject.id, draggableChange)
    },
    async tryToOrderingPrepaid(prepaidId, indexDiff) {
      await this.$store.dispatch('prepaid/orderingPrepaid', {
        id: prepaidId,
        indexDiff,
      })
    },
    // tryToSearchByInput: debounce(function () {
    //   // console.log(this)
    //   this.tryToFetchListFilter()
    // }, 300),
    onSelectAction(action) {
      this.handleStoreDeposit(action)
    },
    formatMode(mode) {
      const map = {
        beforeSelling:'已排程',
        selling: '銷售中',
        afterSelling: '已停售'
      }
      return map[mode]
    },
    tryToRemove(id) {
      this.selectedDeposits = [id]
      this.handleStoreDeposit(-2)
    }
  },
}
</script>

<template>
  <div :class="$style.pageContent">
    <div :class="$style.btnTop" class="btn-top-box">
      <div class="d-sm-flex justify-content-end">
        <span>
          <el-button class="is-round" type="primary" @click="goToAddDeposit({})">
            <BaseIcon name="plus" />
            <span>新增方案</span>
          </el-button>
        </span>
        <span class="ml-sm-3">
          <el-select v-model="action" placeholder="批次執行" :disabled="disabledAction" @change="onSelectAction">
            <el-option label="上架" :value="1"></el-option>
            <el-option label="下架" :value="0"></el-option>
            <el-option label="刪除" :value="-2"></el-option>
          </el-select>
        </span>
      </div>
    </div>

    <BaseTableSearch 
      v-slot="{ fields }" 
      hide-action 
      :default-value="filterData"
      @reset="handleResetSearch"
      @tryToFetchList="tryToFetchList('filter')"
    >
      <el-form-item prop="state">
        <el-select v-model="fields.state" placeholder="上架狀態" @change="tryToFetchList('filter')">
          <el-option label="所有上架狀態" value></el-option>
          <el-option label="已上架" value="1"></el-option>
          <el-option label="下架中" value="0"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item prop="mode">
        <el-select v-model="fields.mode" placeholder="狀態" @change="tryToFetchList('filter')">
          <el-option label="所有狀態" value></el-option>
          <el-option label="已排程" value="beforeSelling"></el-option>
          <el-option label="銷售中" value="selling"></el-option>
          <el-option label="已停售" value="afterSelling"></el-option>
        </el-select>
      </el-form-item>

    </BaseTableSearch>
    <div class="isStylePageContent pt-0">
      <div class="el-table-wrapper">
    
          <el-table v-loading="tryingFetch" element-loading-text="取得儲值金資訊中" :data="tableData" :class="$style['table']" row-key="id" @row-click.once="goToViewPage" @selection-change="handleSelectionChange">
            <el-table-column v-if="!isOrderManager" type="selection" width="80"></el-table-column>

            <el-table-column v-slot="{ row }" label="儲值方案名稱"  min-width="160">
              {{ row.title }} <br />
        
            </el-table-column>
            <el-table-column v-slot="{ row }" label="儲值點數/售價"  min-width="150">
              {{ row.point }} / {{row.price}}
            </el-table-column>
            <el-table-column v-slot="{ row }" label="上架" min-width="60">
              <BaseIcon v-if="row.state" name="check" style="color:#60A32F" />
              <BaseIcon v-else name="minus" icon-style="fal" />
            </el-table-column>
            <el-table-column v-slot="{ row }" label="置頂" min-width="60">
              <BaseIcon v-if="row.keepTop" name="check" style="color:#60A32F" />
              <BaseIcon v-else name="minus" icon-style="fal" />
        
            </el-table-column>
            <el-table-column v-slot="{ row }" label="販售結束日期" min-width="100">
              <template v-if="row.endDate">{{ row.endDate | formatDate }} </template>
              <template v-else><BaseIcon name="minus" icon-style="fal" /></template>
              <br>
              <span class="text-text-light fs-sm">{{formatMode(row.mode)}}</span>
            </el-table-column>
  
            <el-table-column v-slot="{ row }" min-width="60" label="編輯">
              <el-dropdown :hide-on-click="false">
                <span class="el-dropdown-link p-3">
                  <BaseIcon name="ellipsis-h"/>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="goToViewPage(row)">
                    <span>
                      <BaseIcon name="edit" />
                      編輯
                    </span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="tryToRemove(row.id)">
                    <span>
                      <BaseIcon name="trash-alt" />
                      刪除
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
        </el-table-column>
          
          </el-table>
  
      </div>
      <BasePagination ref="pagination" show-size :current-page.sync="currentPage" :page-size.sync="pageSize" />
    </div>
  </div>
  
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
.table {
  // @include layer-elevation(5);
}

.btnTop {
  @include max-sm {
    > * {
      &:not(:first-child) {
        width: 50%;
      }
    }
  }
}
</style>
